var items = {
  "block.minecraft.air": "ar",
  "block.minecraft.stone": "rocha",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito puído",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita puída",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita puída",
  "block.minecraft.grass_block": "bloque de herba",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra árida",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "nicelio carmesí",
  "block.minecraft.warped_nylium": "nicelio deformado",
  "block.minecraft.cobblestone": "pedra",
  "block.minecraft.oak_planks": "táboas de carballo",
  "block.minecraft.spruce_planks": "táboas de abeto",
  "block.minecraft.birch_planks": "táboas de bidueiro",
  "block.minecraft.jungle_planks": "táboas de selva",
  "block.minecraft.acacia_planks": "táboas de acacia",
  "block.minecraft.dark_oak_planks": "táboas de carballo escuro",
  "block.minecraft.crimson_planks": "táboas carmesí",
  "block.minecraft.warped_planks": "táboas deformadas",
  "block.minecraft.oak_sapling": "gromo de carballo",
  "block.minecraft.spruce_sapling": "gromo de abeto",
  "block.minecraft.birch_sapling": "gromo de bidueiro",
  "block.minecraft.jungle_sapling": "gromo de selva",
  "block.minecraft.acacia_sapling": "gromo de acacia",
  "block.minecraft.dark_oak_sapling": "gromo de carballo escuro",
  "block.minecraft.bedrock": "pedra base",
  "block.minecraft.sand": "area",
  "block.minecraft.red_sand": "area vermella",
  "block.minecraft.gravel": "cascallo",
  "block.minecraft.gold_ore": "mineral de ouro",
  "block.minecraft.iron_ore": "mineral de ferro",
  "block.minecraft.coal_ore": "mineral de carbón",
  "block.minecraft.nether_gold_ore": "mineral de ouro do nether",
  "block.minecraft.oak_log": "tronco de carballo",
  "block.minecraft.spruce_log": "tronco de abeto",
  "block.minecraft.birch_log": "tronco de bidueiro",
  "block.minecraft.jungle_log": "tronco de selva",
  "block.minecraft.acacia_log": "tronco de acacia",
  "block.minecraft.dark_oak_log": "tronco de carballo escuro",
  "block.minecraft.crimson_stem": "talo carmesí",
  "block.minecraft.warped_stem": "talo deformado",
  "block.minecraft.stripped_oak_log": "tronco de carballo sen cortiza",
  "block.minecraft.stripped_spruce_log": "tronco de abeto sen cortiza",
  "block.minecraft.stripped_birch_log": "tronco de bidueiro sen cortiza",
  "block.minecraft.stripped_jungle_log": "tronco de selva sen cortiza",
  "block.minecraft.stripped_acacia_log": "tronco de acacia sen cortiza",
  "block.minecraft.stripped_dark_oak_log": "tronco de carballo escuro sen cortiza",
  "block.minecraft.stripped_crimson_stem": "talo carmesí sen cortiza",
  "block.minecraft.stripped_warped_stem": "talo deformado sen cortiza",
  "block.minecraft.stripped_oak_wood": "madeira de carballo sen cortiza",
  "block.minecraft.stripped_spruce_wood": "madeira de abeto sen cortiza",
  "block.minecraft.stripped_birch_wood": "madeira de bidueiro sen cortiza",
  "block.minecraft.stripped_jungle_wood": "madeira de selva sen cortiza",
  "block.minecraft.stripped_acacia_wood": "madeira de acacia sen cortiza",
  "block.minecraft.stripped_dark_oak_wood": "madeira de carballo escuro sen cortiza",
  "block.minecraft.stripped_crimson_hyphae": "talo carmesí sen cortiza",
  "block.minecraft.stripped_warped_hyphae": "hifas deformadas sen cortiza",
  "block.minecraft.oak_wood": "madeira de carballo",
  "block.minecraft.spruce_wood": "madeira de abeto",
  "block.minecraft.birch_wood": "madeira de bidueiro",
  "block.minecraft.jungle_wood": "madeira de selva",
  "block.minecraft.acacia_wood": "madeira de acacia",
  "block.minecraft.dark_oak_wood": "madeira de carballo escuro",
  "block.minecraft.crimson_hyphae": "hifas carmesís",
  "block.minecraft.warped_hyphae": "hifas deformadas",
  "block.minecraft.oak_leaves": "follas de carballo",
  "block.minecraft.spruce_leaves": "follas de abeto",
  "block.minecraft.birch_leaves": "follas de bidueiro",
  "block.minecraft.jungle_leaves": "follas de selva",
  "block.minecraft.acacia_leaves": "follas de acacia",
  "block.minecraft.dark_oak_leaves": "follas de carballo escuro",
  "block.minecraft.sponge": "esponxa",
  "block.minecraft.wet_sponge": "esponxa mollada",
  "block.minecraft.glass": "vidro",
  "block.minecraft.lapis_ore": "mineral de lapislázuli",
  "block.minecraft.lapis_block": "bloque de lapislázuli",
  "block.minecraft.dispenser": "dispensador",
  "block.minecraft.sandstone": "arenito",
  "block.minecraft.chiseled_sandstone": "arenito cicelado",
  "block.minecraft.cut_sandstone": "arenito cortado",
  "block.minecraft.note_block": "bloque musical",
  "block.minecraft.powered_rail": "raíl propulsor",
  "block.minecraft.detector_rail": "raíl detector",
  "block.minecraft.sticky_piston": "pistón pegañento",
  "block.minecraft.cobweb": "arañeira",
  "block.minecraft.grass": "herba",
  "block.minecraft.fern": "fento",
  "block.minecraft.dead_bush": "arbusto morto",
  "block.minecraft.seagrass": "herba mariña",
  "block.minecraft.sea_pickle": "cogombro de mar",
  "block.minecraft.piston": "pistón",
  "block.minecraft.white_wool": "la branca",
  "block.minecraft.orange_wool": "la laranxa",
  "block.minecraft.magenta_wool": "la maxenta",
  "block.minecraft.light_blue_wool": "la azul claro",
  "block.minecraft.yellow_wool": "la amarela",
  "block.minecraft.lime_wool": "la lima",
  "block.minecraft.pink_wool": "la rosa",
  "block.minecraft.gray_wool": "la gris",
  "block.minecraft.light_gray_wool": "la gris claro",
  "block.minecraft.cyan_wool": "la ciano",
  "block.minecraft.purple_wool": "la púrpura",
  "block.minecraft.blue_wool": "la azul",
  "block.minecraft.brown_wool": "la marrón",
  "block.minecraft.green_wool": "la verde",
  "block.minecraft.red_wool": "la vermella",
  "block.minecraft.black_wool": "la negra",
  "block.minecraft.dandelion": "dente de león",
  "block.minecraft.poppy": "papoula",
  "block.minecraft.blue_orchid": "orquídea azul",
  "block.minecraft.allium": "allo bravo",
  "block.minecraft.azure_bluet": "rubiácea",
  "block.minecraft.red_tulip": "tulipán vermello",
  "block.minecraft.orange_tulip": "tulipán laranxa",
  "block.minecraft.white_tulip": "tulipán branco",
  "block.minecraft.pink_tulip": "tulipán rosa",
  "block.minecraft.oxeye_daisy": "margarida",
  "block.minecraft.cornflower": "cardafuso",
  "block.minecraft.lily_of_the_valley": "lirio do val",
  "block.minecraft.wither_rose": "rosa do wither",
  "block.minecraft.brown_mushroom": "cogomelo marrón",
  "block.minecraft.red_mushroom": "cogomelo vermello",
  "block.minecraft.crimson_fungus": "fungo carmesí",
  "block.minecraft.warped_fungus": "fungo deformado",
  "block.minecraft.crimson_roots": "raíces carmesís",
  "block.minecraft.warped_roots": "raíces deformadas",
  "block.minecraft.nether_sprouts": "gromos do nether",
  "block.minecraft.weeping_vines": "trepadeiras choronas",
  "block.minecraft.twisting_vines": "trepadeiras retortas",
  "block.minecraft.sugar_cane": "cana de azucre",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloque de ouro",
  "block.minecraft.iron_block": "bloque de ferro",
  "block.minecraft.oak_slab": "lastra de carballo",
  "block.minecraft.spruce_slab": "lastra de abeto",
  "block.minecraft.birch_slab": "lastra de bidueiro",
  "block.minecraft.jungle_slab": "lastra de selva",
  "block.minecraft.acacia_slab": "lastra de acacia",
  "block.minecraft.dark_oak_slab": "lastra de carballo escuro",
  "block.minecraft.crimson_slab": "lastra carmesí",
  "block.minecraft.warped_slab": "lastra deformada",
  "block.minecraft.stone_slab": "lastra de rocha",
  "block.minecraft.smooth_stone_slab": "lastra de pedra lisa",
  "block.minecraft.sandstone_slab": "lastra de arenito",
  "block.minecraft.cut_sandstone_slab": "lastra de arenito cortado",
  "block.minecraft.petrified_oak_slab": "lastra de carballo petrificado",
  "block.minecraft.cobblestone_slab": "lastra de pedra",
  "block.minecraft.brick_slab": "lastra de ladrillos",
  "block.minecraft.stone_brick_slab": "lastra de ladrillos de pedra",
  "block.minecraft.nether_brick_slab": "lastra de ladrillos do nether",
  "block.minecraft.quartz_slab": "lastra de cuarzo",
  "block.minecraft.red_sandstone_slab": "lastra de arenito vermello",
  "block.minecraft.cut_red_sandstone_slab": "lastra de arenito vermello cortado",
  "block.minecraft.purpur_slab": "lastra de púrpur",
  "block.minecraft.prismarine_slab": "lastra de prismariña",
  "block.minecraft.prismarine_brick_slab": "lastra de ladrillos de prismariña",
  "block.minecraft.dark_prismarine_slab": "lastra de prismariña escura",
  "block.minecraft.smooth_quartz": "bloque de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "arenito vermello liso",
  "block.minecraft.smooth_sandstone": "arenito liso",
  "block.minecraft.smooth_stone": "pedra lisa",
  "block.minecraft.bricks": "ladrillos",
  "block.minecraft.tnt": "dinamita",
  "block.minecraft.bookshelf": "libraría",
  "block.minecraft.mossy_cobblestone": "pedra musgosa",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "facho",
  "block.minecraft.end_rod": "vara do end",
  "block.minecraft.chorus_plant": "planta coral",
  "block.minecraft.chorus_flower": "flor coral",
  "block.minecraft.purpur_block": "bloque de púrpur",
  "block.minecraft.purpur_pillar": "piar de púrpur",
  "block.minecraft.purpur_stairs": "escaleiras de púrpur",
  "block.minecraft.spawner": "xerador",
  "block.minecraft.oak_stairs": "escaleiras de carballo",
  "block.minecraft.chest": "cofre",
  "block.minecraft.diamond_ore": "mineral de diamante",
  "block.minecraft.diamond_block": "bloque de diamante",
  "block.minecraft.crafting_table": "mesa de traballo",
  "block.minecraft.farmland": "terra de cultivo",
  "block.minecraft.furnace": "forno",
  "block.minecraft.ladder": "escada",
  "block.minecraft.rail": "raíl",
  "block.minecraft.cobblestone_stairs": "escaleiras de pedra",
  "block.minecraft.lever": "panca",
  "block.minecraft.stone_pressure_plate": "placa de presión de pedra",
  "block.minecraft.oak_pressure_plate": "placa de presión de carballo",
  "block.minecraft.spruce_pressure_plate": "placa de presión de abeto",
  "block.minecraft.birch_pressure_plate": "placa de presión de bidueiro",
  "block.minecraft.jungle_pressure_plate": "placa de presión de selva",
  "block.minecraft.acacia_pressure_plate": "placa de presión de acacia",
  "block.minecraft.dark_oak_pressure_plate": "placa de presión de carballo escuro",
  "block.minecraft.crimson_pressure_plate": "placa de presión carmesí",
  "block.minecraft.warped_pressure_plate": "placa de presión deformada",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de presión de pedra negra puída",
  "block.minecraft.redstone_ore": "mineral de redstone",
  "block.minecraft.redstone_torch": "facho de redstone",
  "block.minecraft.snow": "neve",
  "block.minecraft.ice": "xeo",
  "block.minecraft.snow_block": "bloque de neve",
  "block.minecraft.cactus": "cacto",
  "block.minecraft.clay": "arxila",
  "block.minecraft.jukebox": "tocadiscos",
  "block.minecraft.oak_fence": "valado de carballo",
  "block.minecraft.spruce_fence": "valado de abeto",
  "block.minecraft.birch_fence": "valado de bidueiro",
  "block.minecraft.jungle_fence": "valado de selva",
  "block.minecraft.acacia_fence": "valado de acacia",
  "block.minecraft.dark_oak_fence": "valado de carballo escuro",
  "block.minecraft.crimson_fence": "valado carmesí",
  "block.minecraft.warped_fence": "valado deformado",
  "block.minecraft.pumpkin": "cabaza",
  "block.minecraft.carved_pumpkin": "cabaza esculpida",
  "block.minecraft.netherrack": "pedra do nether",
  "block.minecraft.soul_sand": "area de ánimas",
  "block.minecraft.soul_soil": "terra de ánimas",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto puído",
  "block.minecraft.soul_torch": "facho de ánimas",
  "block.minecraft.glowstone": "pedra luminosa",
  "block.minecraft.jack_o_lantern": "cabaza de samaín",
  "block.minecraft.oak_trapdoor": "trapela de carballo",
  "block.minecraft.spruce_trapdoor": "trapela de abeto",
  "block.minecraft.birch_trapdoor": "trapela de bidueiro",
  "block.minecraft.jungle_trapdoor": "trapela de selva",
  "block.minecraft.acacia_trapdoor": "trapela de acacia",
  "block.minecraft.dark_oak_trapdoor": "trapela de carballo escuro",
  "block.minecraft.crimson_trapdoor": "trapela carmesí",
  "block.minecraft.warped_trapdoor": "trapela deformada",
  "block.minecraft.infested_stone": "rocha infestada",
  "block.minecraft.infested_cobblestone": "pedra infestada",
  "block.minecraft.infested_stone_bricks": "ladrillos de pedra infestados",
  "block.minecraft.infested_mossy_stone_bricks": "ladrillos de pedra musgosa infestados",
  "block.minecraft.infested_cracked_stone_bricks": "ladrillos de pedra gretada infestados",
  "block.minecraft.infested_chiseled_stone_bricks": "ladrillos de pedra cicelada infestados",
  "block.minecraft.stone_bricks": "ladrillos de pedra",
  "block.minecraft.mossy_stone_bricks": "ladrillos de pedra musgosa",
  "block.minecraft.cracked_stone_bricks": "ladrillos de pedra gretada",
  "block.minecraft.chiseled_stone_bricks": "ladrillos de pedra cicelados",
  "block.minecraft.brown_mushroom_block": "bloque de cogomelo marrón",
  "block.minecraft.red_mushroom_block": "bloque de cogomelo vermello",
  "block.minecraft.mushroom_stem": "pé de cogomelo",
  "block.minecraft.iron_bars": "barrotes de ferro",
  "block.minecraft.chain": "cadea",
  "block.minecraft.glass_pane": "panel de vidro",
  "block.minecraft.melon": "sandía",
  "block.minecraft.vine": "trepadeiras",
  "block.minecraft.oak_fence_gate": "cancela de carballo",
  "block.minecraft.spruce_fence_gate": "cancela de abeto",
  "block.minecraft.birch_fence_gate": "cancela de bidueiro",
  "block.minecraft.jungle_fence_gate": "cancela de selva",
  "block.minecraft.acacia_fence_gate": "cancela de acacia",
  "block.minecraft.dark_oak_fence_gate": "cancela de carballo escuro",
  "block.minecraft.crimson_fence_gate": "cancela carmesí",
  "block.minecraft.warped_fence_gate": "cancela deformada",
  "block.minecraft.brick_stairs": "escaleiras de ladrillos",
  "block.minecraft.stone_brick_stairs": "escaleiras de ladrillos de pedra",
  "block.minecraft.mycelium": "micelio",
  "block.minecraft.lily_pad": "ninfea",
  "block.minecraft.nether_bricks": "ladrillos do nether",
  "block.minecraft.cracked_nether_bricks": "ladrillos do nether gretados",
  "block.minecraft.chiseled_nether_bricks": "ladrillos do nether cicelados",
  "block.minecraft.nether_brick_fence": "valado de ladrillos do nether",
  "block.minecraft.nether_brick_stairs": "escaleiras de ladrillos do nether",
  "block.minecraft.enchanting_table": "mesa de encantamentos",
  "block.minecraft.end_portal_frame": "marco do portal do end",
  "block.minecraft.end_stone": "pedra do end",
  "block.minecraft.end_stone_bricks": "ladrillos de pedra do end",
  "block.minecraft.dragon_egg": "ovo de dragón",
  "block.minecraft.redstone_lamp": "lámpada de redstone",
  "block.minecraft.sandstone_stairs": "escaleiras de arenito",
  "block.minecraft.emerald_ore": "mineral de esmeralda",
  "block.minecraft.ender_chest": "cofre do ender",
  "block.minecraft.tripwire_hook": "gancho de fío trampa",
  "block.minecraft.emerald_block": "bloque de esmeralda",
  "block.minecraft.spruce_stairs": "escaleiras de abeto",
  "block.minecraft.birch_stairs": "escaleiras de bidueiro",
  "block.minecraft.jungle_stairs": "escaleiras de selva",
  "block.minecraft.crimson_stairs": "escaleiras carmesí",
  "block.minecraft.warped_stairs": "escaleiras deformadas",
  "block.minecraft.command_block": "bloque de comandos",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "muro de pedra",
  "block.minecraft.mossy_cobblestone_wall": "muro de pedra musgosa",
  "block.minecraft.brick_wall": "muro de ladrillos",
  "block.minecraft.prismarine_wall": "muro de prismariña",
  "block.minecraft.red_sandstone_wall": "muro de arenito vermello",
  "block.minecraft.mossy_stone_brick_wall": "muro de ladrillos de pedra musgosa",
  "block.minecraft.granite_wall": "muro de granito",
  "block.minecraft.stone_brick_wall": "muro de ladrillos de pedra",
  "block.minecraft.nether_brick_wall": "muro de ladrillos do nether",
  "block.minecraft.andesite_wall": "muro de andesita",
  "block.minecraft.red_nether_brick_wall": "muro de ladrillos do nether vermellos",
  "block.minecraft.sandstone_wall": "muro de arenito",
  "block.minecraft.end_stone_brick_wall": "muro de ladrillos de pedra do end",
  "block.minecraft.diorite_wall": "muro de diorita",
  "block.minecraft.blackstone_wall": "muro de pedra negra",
  "block.minecraft.polished_blackstone_wall": "muro de pedra negra puída",
  "block.minecraft.polished_blackstone_brick_wall": "muro de ladrillos de pedra negra puída",
  "block.minecraft.stone_button": "botón de pedra",
  "block.minecraft.oak_button": "botón de carballo",
  "block.minecraft.spruce_button": "botón de abeto",
  "block.minecraft.birch_button": "botón de bidueiro",
  "block.minecraft.jungle_button": "botón de selva",
  "block.minecraft.acacia_button": "botón de acacia",
  "block.minecraft.dark_oak_button": "botón de carballo escuro",
  "block.minecraft.crimson_button": "botón carmesí",
  "block.minecraft.warped_button": "botón deformado",
  "block.minecraft.polished_blackstone_button": "botón de pedra negra puída",
  "block.minecraft.anvil": "bigornia",
  "block.minecraft.chipped_anvil": "bigornia danada",
  "block.minecraft.damaged_anvil": "bigornia moi danada",
  "block.minecraft.trapped_chest": "cofre trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de presión para peso lixeiro",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de presión para peso elevado",
  "block.minecraft.daylight_detector": "sensor de luz solar",
  "block.minecraft.redstone_block": "bloque de redstone",
  "block.minecraft.nether_quartz_ore": "mineral de cuarzo do nether",
  "block.minecraft.hopper": "funil",
  "block.minecraft.chiseled_quartz_block": "bloque de cuarzo cicelado",
  "block.minecraft.quartz_block": "bloque de cuarzo",
  "block.minecraft.quartz_bricks": "ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "piar de cuarzo",
  "block.minecraft.quartz_stairs": "escaleiras de cuarzo",
  "block.minecraft.activator_rail": "raíl activador",
  "block.minecraft.dropper": "lanzador",
  "block.minecraft.white_terracotta": "terracota branca",
  "block.minecraft.orange_terracotta": "terracota laranxa",
  "block.minecraft.magenta_terracotta": "terracota maxenta",
  "block.minecraft.light_blue_terracotta": "terracota azul claro",
  "block.minecraft.yellow_terracotta": "terracota amarela",
  "block.minecraft.lime_terracotta": "terracota lima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota gris",
  "block.minecraft.light_gray_terracotta": "terracota gris claro",
  "block.minecraft.cyan_terracotta": "terracota ciano",
  "block.minecraft.purple_terracotta": "terracota púrpura",
  "block.minecraft.blue_terracotta": "terracota azul",
  "block.minecraft.brown_terracotta": "terracota marrón",
  "block.minecraft.green_terracotta": "terracota verde",
  "block.minecraft.red_terracotta": "terracota vermella",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "barreira",
  "block.minecraft.iron_trapdoor": "trapela de ferro",
  "block.minecraft.hay_block": "bala de palla",
  "block.minecraft.white_carpet": "alfombra branca",
  "block.minecraft.orange_carpet": "alfombra laranxa",
  "block.minecraft.magenta_carpet": "alfombra maxenta",
  "block.minecraft.light_blue_carpet": "alfombra azul claro",
  "block.minecraft.yellow_carpet": "alfombra amarela",
  "block.minecraft.lime_carpet": "alfombra lima",
  "block.minecraft.pink_carpet": "alfombra rosa",
  "block.minecraft.gray_carpet": "alfombra gris",
  "block.minecraft.light_gray_carpet": "alfombra gris claro",
  "block.minecraft.cyan_carpet": "alfombra ciano",
  "block.minecraft.purple_carpet": "alfombra púrpura",
  "block.minecraft.blue_carpet": "alfombra azul",
  "block.minecraft.brown_carpet": "alfombra marrón",
  "block.minecraft.green_carpet": "alfombra verde",
  "block.minecraft.red_carpet": "alfombra vermella",
  "block.minecraft.black_carpet": "alfombra negra",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloque de carbón",
  "block.minecraft.packed_ice": "xeo compactado",
  "block.minecraft.acacia_stairs": "escaleiras de acacia",
  "block.minecraft.dark_oak_stairs": "escaleiras de carballo escuro",
  "block.minecraft.slime_block": "bloque de slime",
  "block.minecraft.grass_path": "camiño de herba",
  "block.minecraft.sunflower": "xirasol",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "roseira",
  "block.minecraft.peony": "peonia",
  "block.minecraft.tall_grass": "herba alta",
  "block.minecraft.large_fern": "fento grande",
  "block.minecraft.white_stained_glass": "vidro tinguido de branco",
  "block.minecraft.orange_stained_glass": "vidro tinguido de laranxa",
  "block.minecraft.magenta_stained_glass": "vidro tinguido de maxenta",
  "block.minecraft.light_blue_stained_glass": "vidro tinguido de azul claro",
  "block.minecraft.yellow_stained_glass": "vidro tinguido de amarelo",
  "block.minecraft.lime_stained_glass": "vidro tinguido de lima",
  "block.minecraft.pink_stained_glass": "vidro tinguido de rosa",
  "block.minecraft.gray_stained_glass": "vidro tinguido de gris",
  "block.minecraft.light_gray_stained_glass": "vidro tinguido de gris claro",
  "block.minecraft.cyan_stained_glass": "vidro tinguido de ciano",
  "block.minecraft.purple_stained_glass": "vidro tinguido de púrpura",
  "block.minecraft.blue_stained_glass": "vidro tinguido de azul",
  "block.minecraft.brown_stained_glass": "vidro tinguido de marrón",
  "block.minecraft.green_stained_glass": "vidro tinguido de verde",
  "block.minecraft.red_stained_glass": "vidro tinguido de vermello",
  "block.minecraft.black_stained_glass": "vidro tinguido de negro",
  "block.minecraft.white_stained_glass_pane": "panel de vidro tinguido de branco",
  "block.minecraft.orange_stained_glass_pane": "panel de vidro tinguido de laranxa",
  "block.minecraft.magenta_stained_glass_pane": "panel de vidro tinguido de maxenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel de vidro tinguido de azul claro",
  "block.minecraft.yellow_stained_glass_pane": "panel de vidro tinguido de amarelo",
  "block.minecraft.lime_stained_glass_pane": "panel de vidro tinguido de lima",
  "block.minecraft.pink_stained_glass_pane": "panel de vidro tinguido de rosa",
  "block.minecraft.gray_stained_glass_pane": "panel de vidro tinguido de gris",
  "block.minecraft.light_gray_stained_glass_pane": "panel de vidro tinguido de gris claro",
  "block.minecraft.cyan_stained_glass_pane": "panel de vidro tinguido de ciano",
  "block.minecraft.purple_stained_glass_pane": "panel de vidro tinguido de púrpura",
  "block.minecraft.blue_stained_glass_pane": "panel de vidro tinguido de azul",
  "block.minecraft.brown_stained_glass_pane": "panel de vidro tinguido de marrón",
  "block.minecraft.green_stained_glass_pane": "panel de vidro tinguido de verde",
  "block.minecraft.red_stained_glass_pane": "panel de vidro tinguido de vermello",
  "block.minecraft.black_stained_glass_pane": "panel de vidro tinguido de negro",
  "block.minecraft.prismarine": "prismariña",
  "block.minecraft.prismarine_bricks": "ladrillos de prismariña",
  "block.minecraft.dark_prismarine": "prismariña escura",
  "block.minecraft.prismarine_stairs": "escaleiras de prismariña",
  "block.minecraft.prismarine_brick_stairs": "escaleiras de ladrillos de prismariña",
  "block.minecraft.dark_prismarine_stairs": "escaleiras de prismariña escura",
  "block.minecraft.sea_lantern": "lanterna mariña",
  "block.minecraft.red_sandstone": "arenito vermello",
  "block.minecraft.chiseled_red_sandstone": "arenito vermello cicelado",
  "block.minecraft.cut_red_sandstone": "arenito vermello cortado",
  "block.minecraft.red_sandstone_stairs": "escaleiras de arenito vermello",
  "block.minecraft.repeating_command_block": "bloque de comandos de repetición",
  "block.minecraft.chain_command_block": "bloque de comandos en cadea",
  "block.minecraft.magma_block": "bloque de magma",
  "block.minecraft.nether_wart_block": "bloque de espullas do nether",
  "block.minecraft.warped_wart_block": "bloque de espullas deformadas",
  "block.minecraft.red_nether_bricks": "ladrillos do nether vermellos",
  "block.minecraft.bone_block": "bloque de ósos",
  "block.minecraft.structure_void": "bloque baleiro",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caixa de shulker",
  "block.minecraft.white_shulker_box": "caixa de shulker branca",
  "block.minecraft.orange_shulker_box": "caixa de shulker laranxa",
  "block.minecraft.magenta_shulker_box": "caixa de shulker maxenta",
  "block.minecraft.light_blue_shulker_box": "caixa de shulker azul claro",
  "block.minecraft.yellow_shulker_box": "caixa de shulker amarela",
  "block.minecraft.lime_shulker_box": "caixa de shulker lima",
  "block.minecraft.pink_shulker_box": "caixa de shulker rosa",
  "block.minecraft.gray_shulker_box": "caixa de shulker gris",
  "block.minecraft.light_gray_shulker_box": "caixa de shulker gris claro",
  "block.minecraft.cyan_shulker_box": "caixa de shulker ciano",
  "block.minecraft.purple_shulker_box": "caixa de shulker púrpura",
  "block.minecraft.blue_shulker_box": "caixa de shulker azul",
  "block.minecraft.brown_shulker_box": "caixa de shulker marrón",
  "block.minecraft.green_shulker_box": "caixa de shulker verde",
  "block.minecraft.red_shulker_box": "caixa de shulker vermella",
  "block.minecraft.black_shulker_box": "caixa de shulker negra",
  "block.minecraft.white_glazed_terracotta": "azulexo branco",
  "block.minecraft.orange_glazed_terracotta": "azulexo laranxa",
  "block.minecraft.magenta_glazed_terracotta": "azulexo maxenta",
  "block.minecraft.light_blue_glazed_terracotta": "azulexo azul claro",
  "block.minecraft.yellow_glazed_terracotta": "azulexo amarelo",
  "block.minecraft.lime_glazed_terracotta": "azulexo lima",
  "block.minecraft.pink_glazed_terracotta": "azulexo rosa",
  "block.minecraft.gray_glazed_terracotta": "azulexo gris",
  "block.minecraft.light_gray_glazed_terracotta": "azulexo gris claro",
  "block.minecraft.cyan_glazed_terracotta": "azulexo ciano",
  "block.minecraft.purple_glazed_terracotta": "azulexo púrpura",
  "block.minecraft.blue_glazed_terracotta": "azulexo azul",
  "block.minecraft.brown_glazed_terracotta": "azulexo marrón",
  "block.minecraft.green_glazed_terracotta": "azulexo verde",
  "block.minecraft.red_glazed_terracotta": "azulexo vermello",
  "block.minecraft.black_glazed_terracotta": "azulexo negro",
  "block.minecraft.white_concrete": "formigón branco",
  "block.minecraft.orange_concrete": "formigón laranxa",
  "block.minecraft.magenta_concrete": "formigón maxenta",
  "block.minecraft.light_blue_concrete": "formigón azul claro",
  "block.minecraft.yellow_concrete": "formigón amarelo",
  "block.minecraft.lime_concrete": "formigón lima",
  "block.minecraft.pink_concrete": "formigón rosa",
  "block.minecraft.gray_concrete": "formigón gris",
  "block.minecraft.light_gray_concrete": "formigón gris claro",
  "block.minecraft.cyan_concrete": "formigón ciano",
  "block.minecraft.purple_concrete": "formigón púrpura",
  "block.minecraft.blue_concrete": "formigón azul",
  "block.minecraft.brown_concrete": "formigón marrón",
  "block.minecraft.green_concrete": "formigón verde",
  "block.minecraft.red_concrete": "formigón vermello",
  "block.minecraft.black_concrete": "formigón negro",
  "block.minecraft.white_concrete_powder": "cemento branco",
  "block.minecraft.orange_concrete_powder": "cemento laranxa",
  "block.minecraft.magenta_concrete_powder": "cemento maxenta",
  "block.minecraft.light_blue_concrete_powder": "cemento azul claro",
  "block.minecraft.yellow_concrete_powder": "cemento amarelo",
  "block.minecraft.lime_concrete_powder": "cemento lima",
  "block.minecraft.pink_concrete_powder": "cemento rosa",
  "block.minecraft.gray_concrete_powder": "cemento gris",
  "block.minecraft.light_gray_concrete_powder": "cemento gris claro",
  "block.minecraft.cyan_concrete_powder": "cemento ciano",
  "block.minecraft.purple_concrete_powder": "cemento púrpura",
  "block.minecraft.blue_concrete_powder": "cemento azul",
  "block.minecraft.brown_concrete_powder": "cemento marrón",
  "block.minecraft.green_concrete_powder": "cemento verde",
  "block.minecraft.red_concrete_powder": "cemento vermello",
  "block.minecraft.black_concrete_powder": "cemento negro",
  "block.minecraft.turtle_egg": "ovo de tartaruga",
  "block.minecraft.dead_tube_coral_block": "bloque de coral de tubo morto",
  "block.minecraft.dead_brain_coral_block": "bloque de coral de cerebro morto",
  "block.minecraft.dead_bubble_coral_block": "bloque de coral de burbulla morto",
  "block.minecraft.dead_fire_coral_block": "bloque de coral de lume morto",
  "block.minecraft.dead_horn_coral_block": "bloque de coral de corno morto",
  "block.minecraft.tube_coral_block": "bloque de coral de tubo",
  "block.minecraft.brain_coral_block": "bloque de coral de cerebro",
  "block.minecraft.bubble_coral_block": "bloque de coral burbulla",
  "block.minecraft.fire_coral_block": "bloque de coral de lume",
  "block.minecraft.horn_coral_block": "bloque de coral de corno",
  "block.minecraft.tube_coral": "coral de tubo",
  "block.minecraft.brain_coral": "coral de cerebro",
  "block.minecraft.bubble_coral": "coral de burbulla",
  "block.minecraft.fire_coral": "coral de lume",
  "block.minecraft.horn_coral": "coral de corno",
  "block.minecraft.dead_brain_coral": "coral de cerebro morto",
  "block.minecraft.dead_bubble_coral": "coral de burbulla morto",
  "block.minecraft.dead_fire_coral": "coral de lume morto",
  "block.minecraft.dead_horn_coral": "coral de cornos morto",
  "block.minecraft.dead_tube_coral": "coral de tubo morto",
  "block.minecraft.tube_coral_fan": "gorgonia de tubo",
  "block.minecraft.brain_coral_fan": "gorgonia de cerebro",
  "block.minecraft.bubble_coral_fan": "gorgonia de burbulla",
  "block.minecraft.fire_coral_fan": "gorgonia de lume",
  "block.minecraft.horn_coral_fan": "gorgonia de corno",
  "block.minecraft.dead_tube_coral_fan": "gorgonia de tubo morta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia de cerebro morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia de burbulla morta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de lume morta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia de corno morta",
  "block.minecraft.blue_ice": "xeo azul",
  "block.minecraft.conduit": "canalizador",
  "block.minecraft.polished_granite_stairs": "escaleiras de granito puído",
  "block.minecraft.smooth_red_sandstone_stairs": "escaleiras de arenito vermello liso",
  "block.minecraft.mossy_stone_brick_stairs": "escaleiras de ladrillos de pedra musgosa",
  "block.minecraft.polished_diorite_stairs": "escaleiras de diorita puída",
  "block.minecraft.mossy_cobblestone_stairs": "escaleiras de pedra musgosa",
  "block.minecraft.end_stone_brick_stairs": "escaleiras de ladrillos de pedra do end",
  "block.minecraft.stone_stairs": "escaleiras de rocha",
  "block.minecraft.smooth_sandstone_stairs": "escaleiras de arenito liso",
  "block.minecraft.smooth_quartz_stairs": "escaleiras de cuarzo liso",
  "block.minecraft.granite_stairs": "escaleiras de granito",
  "block.minecraft.andesite_stairs": "escaleiras de andesita",
  "block.minecraft.red_nether_brick_stairs": "escaleiras de ladrillos do nether vermellos",
  "block.minecraft.polished_andesite_stairs": "escaleiras de andesita puída",
  "block.minecraft.diorite_stairs": "escaleiras de diorita",
  "block.minecraft.polished_granite_slab": "lastra de granito puído",
  "block.minecraft.smooth_red_sandstone_slab": "lastra de arenito vermello liso",
  "block.minecraft.mossy_stone_brick_slab": "lastra de ladrillos de pedra musgosa",
  "block.minecraft.polished_diorite_slab": "lastra de diorita puída",
  "block.minecraft.mossy_cobblestone_slab": "lastra de pedra musgosa",
  "block.minecraft.end_stone_brick_slab": "lastra de ladrillos de pedra do end",
  "block.minecraft.smooth_sandstone_slab": "lastra de arenito liso",
  "block.minecraft.smooth_quartz_slab": "lastra de cuarzo liso",
  "block.minecraft.granite_slab": "lastra de granito",
  "block.minecraft.andesite_slab": "lastra de andesita",
  "block.minecraft.red_nether_brick_slab": "lastra de ladrillos do nether vermellos",
  "block.minecraft.polished_andesite_slab": "lastra de andesita puída",
  "block.minecraft.diorite_slab": "lastra de diorita",
  "block.minecraft.scaffolding": "estada",
  "block.minecraft.iron_door": "porta de ferro",
  "block.minecraft.oak_door": "porta de carballo",
  "block.minecraft.spruce_door": "porta de abeto",
  "block.minecraft.birch_door": "porta de bidueiro",
  "block.minecraft.jungle_door": "porta de selva",
  "block.minecraft.acacia_door": "porta de acacia",
  "block.minecraft.dark_oak_door": "porta de carballo escuro",
  "block.minecraft.crimson_door": "porta carmesí",
  "block.minecraft.warped_door": "porta deformada",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloque de estrutura",
  "block.minecraft.jigsaw": "bloque de crebacabezas",
  "item.minecraft.turtle_helmet": "cuncha de tartaruga□□na cabeza:□armadura: +2",
  "item.minecraft.scute": "escama de tartaruga",
  "item.minecraft.iron_shovel": "pa de ferro□□na man principal:□dano de ataque: +3.5□velocidade de ataque: -3",
  "item.minecraft.iron_pickaxe": "pico de ferro□□na man principal:□dano de ataque: +3□velocidade de ataque: -2.8",
  "item.minecraft.iron_axe": "machada de ferro□□na man principal:□dano de ataque: +8□velocidade de ataque: -3.1",
  "item.minecraft.flint_and_steel": "chisqueiro",
  "item.minecraft.apple": "mazá",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "frecha",
  "item.minecraft.coal": "carbón",
  "item.minecraft.charcoal": "carbón vexetal",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "lingote de ferro",
  "item.minecraft.gold_ingot": "lingote de ouro",
  "item.minecraft.netherite_ingot": "lingote de netherita",
  "item.minecraft.netherite_scrap": "anacos de netherita",
  "item.minecraft.iron_sword": "espada de ferro□□na man principal:□dano de ataque: +5□velocidade de ataque: -2.4",
  "item.minecraft.wooden_sword": "espada de madeira□□na man principal:□dano de ataque: +3□velocidade de ataque: -2.4",
  "item.minecraft.wooden_shovel": "pa de madeira□□na man principal:□dano de ataque: +1.5□velocidade de ataque: -3",
  "item.minecraft.wooden_pickaxe": "pico de madeira□□na man principal:□dano de ataque: +1□velocidade de ataque: -2.8",
  "item.minecraft.wooden_axe": "machada de madeira□□na man principal:□dano de ataque: +6□velocidade de ataque: -3.2",
  "item.minecraft.stone_sword": "espada de pedra□□na man principal:□dano de ataque: +4□velocidade de ataque: -2.4",
  "item.minecraft.stone_shovel": "pa de pedra□□na man principal:□dano de ataque: +2.5□velocidade de ataque: -3",
  "item.minecraft.stone_pickaxe": "pico de pedra□□na man principal:□dano de ataque: +2□velocidade de ataque: -2.8",
  "item.minecraft.stone_axe": "machada de pedra□□na man principal:□dano de ataque: +8□velocidade de ataque: -3.2",
  "item.minecraft.diamond_sword": "espada de diamante□□na man principal:□dano de ataque: +6□velocidade de ataque: -2.4",
  "item.minecraft.diamond_shovel": "pa de diamante□□na man principal:□dano de ataque: +4.5□velocidade de ataque: -3",
  "item.minecraft.diamond_pickaxe": "pico de diamante□□na man principal:□dano de ataque: +4□velocidade de ataque: -2.8",
  "item.minecraft.diamond_axe": "machada de diamante□□na man principal:□dano de ataque: +8□velocidade de ataque: -3",
  "item.minecraft.stick": "pau",
  "item.minecraft.bowl": "cunca",
  "item.minecraft.mushroom_stew": "estufado de cogomelos",
  "item.minecraft.golden_sword": "espada de ouro□□na man principal:□dano de ataque: +3□velocidade de ataque: -2.4",
  "item.minecraft.golden_shovel": "pa de ouro□□na man principal:□dano de ataque: +1.5□velocidade de ataque: -3",
  "item.minecraft.golden_pickaxe": "pico de ouro□□na man principal:□dano de ataque: +1□velocidade de ataque: -2.8",
  "item.minecraft.golden_axe": "machada de ouro□□na man principal:□dano de ataque: +6□velocidade de ataque: -3",
  "item.minecraft.netherite_sword": "espada de netherita□□na man principal:□dano de ataque: +7□velocidade de ataque: -2.4",
  "item.minecraft.netherite_shovel": "pa de netherita□□na man principal:□dano de ataque: +5.5□velocidade de ataque: -3",
  "item.minecraft.netherite_pickaxe": "pico de netherita□□na man principal:□dano de ataque: +5□velocidade de ataque: -2.8",
  "item.minecraft.netherite_axe": "machada de netherita□□na man principal:□dano de ataque: +9□velocidade de ataque: -3",
  "item.minecraft.string": "fío",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "sacho de madeira□□na man principal:□velocidade de ataque: -3",
  "item.minecraft.stone_hoe": "sacho de pedra□□na man principal:□velocidade de ataque: -2",
  "item.minecraft.iron_hoe": "sacho de ferro□□na man principal:□velocidade de ataque: -1",
  "item.minecraft.diamond_hoe": "sacho de diamante□□na man principal:",
  "item.minecraft.golden_hoe": "sacho de ouro□□na man principal:□velocidade de ataque: -3",
  "item.minecraft.netherite_hoe": "sacho de netherita□□na man principal:",
  "item.minecraft.wheat_seeds": "sementes de trigo",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "helmo de coiro□□na cabeza:□armadura: +1",
  "item.minecraft.leather_chestplate": "coiraza de coiro□□no corpo:□armadura: +3",
  "item.minecraft.leather_leggings": "perneiras de coiro□□nas pernas:□armadura: +2",
  "item.minecraft.leather_boots": "botas de coiro□□nos pés:□armadura: +1",
  "item.minecraft.chainmail_helmet": "helmo de cota de mallas□□na cabeza:□armadura: +2",
  "item.minecraft.chainmail_chestplate": "coiraza de cota de malla□□no corpo:□armadura: +5",
  "item.minecraft.chainmail_leggings": "perneiras de cota de malla□□nas pernas:□armadura: +4",
  "item.minecraft.chainmail_boots": "botas de cota de malla□□nos pés:□armadura: +1",
  "item.minecraft.iron_helmet": "helmo de ferro□□na cabeza:□armadura: +2",
  "item.minecraft.iron_chestplate": "coiraza de ferro□□no corpo:□armadura: +6",
  "item.minecraft.iron_leggings": "perneiras de ferro□□nas pernas:□armadura: +5",
  "item.minecraft.iron_boots": "botas de ferro□□nos pés:□armadura: +2",
  "item.minecraft.diamond_helmet": "helmo de diamante□□na cabeza:□armadura: +3□resistencia da armadura: +2",
  "item.minecraft.diamond_chestplate": "coiraza de diamante□□no corpo:□armadura: +8□resistencia da armadura: +2",
  "item.minecraft.diamond_leggings": "perneiras de diamante□□nas pernas:□armadura: +6□resistencia da armadura: +2",
  "item.minecraft.diamond_boots": "botas de diamante□□nos pés:□armadura: +3□resistencia da armadura: +2",
  "item.minecraft.golden_helmet": "helmo de ouro□□na cabeza:□armadura: +2",
  "item.minecraft.golden_chestplate": "coiraza de ouro□□no corpo:□armadura: +5",
  "item.minecraft.golden_leggings": "perneiras de ouro□□nas pernas:□armadura: +3",
  "item.minecraft.golden_boots": "botas de ouro□□nos pés:□armadura: +1",
  "item.minecraft.netherite_helmet": "casco de netherita□□na cabeza:□armadura: +3□resistencia da armadura: +3□resistencia ao empurrón: +1",
  "item.minecraft.netherite_chestplate": "coiraza de netherita□□no corpo:□armadura: +8□resistencia da armadura: +3□resistencia ao empurrón: +1",
  "item.minecraft.netherite_leggings": "perneiras de netherita□□nas pernas:□armadura: +6□resistencia da armadura: +3□resistencia ao empurrón: +1",
  "item.minecraft.netherite_boots": "botas de netherita□□nos pés:□armadura: +3□resistencia da armadura: +3□resistencia ao empurrón: +1",
  "item.minecraft.flint": "pedernal",
  "item.minecraft.porkchop": "costeleta de porco crúa",
  "item.minecraft.cooked_porkchop": "costeleta de porco cociñada",
  "item.minecraft.painting": "cadro",
  "item.minecraft.golden_apple": "mazá dourada",
  "item.minecraft.enchanted_golden_apple": "mazá de ouro encantada",
  "block.minecraft.oak_sign": "letreiro de carballo",
  "block.minecraft.spruce_sign": "letreiro de abeto",
  "block.minecraft.birch_sign": "letreiro de bidueiro",
  "block.minecraft.jungle_sign": "letreiro de selva",
  "block.minecraft.acacia_sign": "letreiro de acacia",
  "block.minecraft.dark_oak_sign": "letreiro de carballo escuro",
  "block.minecraft.crimson_sign": "letreiro carmesí",
  "block.minecraft.warped_sign": "letreiro deformado",
  "item.minecraft.bucket": "balde",
  "item.minecraft.water_bucket": "balde de auga",
  "item.minecraft.lava_bucket": "balde de lava",
  "item.minecraft.minecart": "vagoneta",
  "item.minecraft.saddle": "sela",
  "item.minecraft.redstone": "po de redstone",
  "item.minecraft.snowball": "bóla de neve",
  "item.minecraft.oak_boat": "barca de carballo",
  "item.minecraft.leather": "coiro",
  "item.minecraft.milk_bucket": "balde de leite",
  "item.minecraft.pufferfish_bucket": "balde con peixe globo",
  "item.minecraft.salmon_bucket": "balde con salmón",
  "item.minecraft.cod_bucket": "balde con bacallau",
  "item.minecraft.tropical_fish_bucket": "balde con peixe tropical",
  "item.minecraft.brick": "ladrillo",
  "item.minecraft.clay_ball": "bóla de arxila",
  "block.minecraft.dried_kelp_block": "bloque de alga seca",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "bóla de slime",
  "item.minecraft.chest_minecart": "vagoneta con cofre",
  "item.minecraft.furnace_minecart": "vagoneta con forno",
  "item.minecraft.egg": "ovo",
  "item.minecraft.compass": "compás",
  "item.minecraft.fishing_rod": "cana de pescar",
  "item.minecraft.clock": "reloxo",
  "item.minecraft.glowstone_dust": "po de pedra luminosa",
  "item.minecraft.cod": "bacallau cru",
  "item.minecraft.salmon": "salmón cru",
  "item.minecraft.tropical_fish": "peixe tropical",
  "item.minecraft.pufferfish": "peixe globo",
  "item.minecraft.cooked_cod": "bacallau cociñado",
  "item.minecraft.cooked_salmon": "salmón cociñado",
  "item.minecraft.ink_sac": "saco de borra",
  "item.minecraft.red_dye": "tintura vermella",
  "item.minecraft.green_dye": "tintura verde",
  "item.minecraft.cocoa_beans": "sementes de cacao",
  "item.minecraft.lapis_lazuli": "lapislázuli",
  "item.minecraft.purple_dye": "tintura púrpura",
  "item.minecraft.cyan_dye": "tintura ciano",
  "item.minecraft.light_gray_dye": "tintura gris claro",
  "item.minecraft.gray_dye": "tintura gris",
  "item.minecraft.pink_dye": "tintura rosa",
  "item.minecraft.lime_dye": "tintura lima",
  "item.minecraft.yellow_dye": "tintura amarela",
  "item.minecraft.light_blue_dye": "tintura azul claro",
  "item.minecraft.magenta_dye": "tintura maxenta",
  "item.minecraft.orange_dye": "tintura laranxa",
  "item.minecraft.bone_meal": "fariña de óso",
  "item.minecraft.blue_dye": "tintura azul",
  "item.minecraft.brown_dye": "tintura marrón",
  "item.minecraft.black_dye": "tintura negra",
  "item.minecraft.white_dye": "tintura branca",
  "item.minecraft.bone": "óso",
  "item.minecraft.sugar": "azucre",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "cama branca",
  "block.minecraft.orange_bed": "cama laranxa",
  "block.minecraft.magenta_bed": "cama maxenta",
  "block.minecraft.light_blue_bed": "cama azul claro",
  "block.minecraft.yellow_bed": "cama amarela",
  "block.minecraft.lime_bed": "cama lima",
  "block.minecraft.pink_bed": "cama rosa",
  "block.minecraft.gray_bed": "cama gris",
  "block.minecraft.light_gray_bed": "cama gris claro",
  "block.minecraft.cyan_bed": "cama ciano",
  "block.minecraft.purple_bed": "cama púrpura",
  "block.minecraft.blue_bed": "cama azul",
  "block.minecraft.brown_bed": "cama marrón",
  "block.minecraft.green_bed": "cama verde",
  "block.minecraft.red_bed": "cama vermella",
  "block.minecraft.black_bed": "cama negra",
  "item.minecraft.cookie": "galleta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tesoiras",
  "item.minecraft.melon_slice": "anaco de sandía",
  "item.minecraft.dried_kelp": "alga seca",
  "item.minecraft.pumpkin_seeds": "sementes de cabaza",
  "item.minecraft.melon_seeds": "sementes de sandía",
  "item.minecraft.beef": "filete cru",
  "item.minecraft.cooked_beef": "filete cociñado",
  "item.minecraft.chicken": "polo cru",
  "item.minecraft.cooked_chicken": "polo cociñado",
  "item.minecraft.rotten_flesh": "carne podre",
  "item.minecraft.ender_pearl": "perla do ender",
  "item.minecraft.blaze_rod": "vara de blaze",
  "item.minecraft.ghast_tear": "bágoa de ghast",
  "item.minecraft.gold_nugget": "pebida de ouro",
  "item.minecraft.nether_wart": "espulla do nether",
  "item.minecraft.potion": "poción non fabricable□sen efectos",
  "item.minecraft.glass_bottle": "frasco de vidro",
  "item.minecraft.spider_eye": "ollo de araña",
  "item.minecraft.fermented_spider_eye": "ollo de araña fermentado",
  "item.minecraft.blaze_powder": "po de blaze",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "destilador",
  "block.minecraft.cauldron": "caldeiro",
  "item.minecraft.ender_eye": "ollo do ender",
  "item.minecraft.glistering_melon_slice": "anaco de sandía relucente",
  "item.minecraft.bat_spawn_egg": "xerar morcego",
  "item.minecraft.bee_spawn_egg": "xerar abella",
  "item.minecraft.blaze_spawn_egg": "xerar blaze",
  "item.minecraft.cat_spawn_egg": "xerar gato",
  "item.minecraft.cave_spider_spawn_egg": "xerar araña de cova",
  "item.minecraft.chicken_spawn_egg": "xerar galiña",
  "item.minecraft.cod_spawn_egg": "xerar bacallau",
  "item.minecraft.cow_spawn_egg": "xerar vaca",
  "item.minecraft.creeper_spawn_egg": "xerar creeper",
  "item.minecraft.dolphin_spawn_egg": "xerar golfiño",
  "item.minecraft.donkey_spawn_egg": "xerar burro",
  "item.minecraft.drowned_spawn_egg": "xerar afogado",
  "item.minecraft.elder_guardian_spawn_egg": "xerar gardián ancián",
  "item.minecraft.enderman_spawn_egg": "xerar enderman",
  "item.minecraft.endermite_spawn_egg": "xerar endermite",
  "item.minecraft.evoker_spawn_egg": "xerar invocador",
  "item.minecraft.fox_spawn_egg": "xerar raposo",
  "item.minecraft.ghast_spawn_egg": "xerar ghast",
  "item.minecraft.guardian_spawn_egg": "xerar gardián",
  "item.minecraft.hoglin_spawn_egg": "xerar hoglin",
  "item.minecraft.horse_spawn_egg": "xerar cabalo",
  "item.minecraft.husk_spawn_egg": "xerar momia",
  "item.minecraft.llama_spawn_egg": "xerar llama",
  "item.minecraft.magma_cube_spawn_egg": "xerar cubo de magma",
  "item.minecraft.mooshroom_spawn_egg": "xerar vacumelo",
  "item.minecraft.mule_spawn_egg": "xerar mula",
  "item.minecraft.ocelot_spawn_egg": "xerar ocelote",
  "item.minecraft.panda_spawn_egg": "xerar panda",
  "item.minecraft.parrot_spawn_egg": "xerar papagaio",
  "item.minecraft.phantom_spawn_egg": "xerar pantasma",
  "item.minecraft.pig_spawn_egg": "xerar porco",
  "item.minecraft.piglin_spawn_egg": "xerar piglin",
  "item.minecraft.pillager_spawn_egg": "xerar saqueador",
  "item.minecraft.polar_bear_spawn_egg": "xerar oso polar",
  "item.minecraft.pufferfish_spawn_egg": "xerar peixe globo",
  "item.minecraft.rabbit_spawn_egg": "xerar coello",
  "item.minecraft.ravager_spawn_egg": "xerar devastador",
  "item.minecraft.salmon_spawn_egg": "xerar salmón",
  "item.minecraft.sheep_spawn_egg": "xerar ovella",
  "item.minecraft.shulker_spawn_egg": "xerar shulker",
  "item.minecraft.silverfish_spawn_egg": "xerar lepisma",
  "item.minecraft.skeleton_spawn_egg": "xerar esqueleto",
  "item.minecraft.skeleton_horse_spawn_egg": "xerar cabalo esqueleto",
  "item.minecraft.slime_spawn_egg": "xerar slime",
  "item.minecraft.spider_spawn_egg": "xerar araña",
  "item.minecraft.squid_spawn_egg": "xerar lura",
  "item.minecraft.stray_spawn_egg": "xerar esqueleto glacial",
  "item.minecraft.strider_spawn_egg": "xerar strider",
  "item.minecraft.trader_llama_spawn_egg": "xerar llama ambulante",
  "item.minecraft.tropical_fish_spawn_egg": "xerar peixe tropical",
  "item.minecraft.turtle_spawn_egg": "xerar tartaruga",
  "item.minecraft.vex_spawn_egg": "xerar espírito",
  "item.minecraft.villager_spawn_egg": "xerar aldeán",
  "item.minecraft.vindicator_spawn_egg": "xerar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "xerar vendedor ambulante",
  "item.minecraft.witch_spawn_egg": "xerar meiga",
  "item.minecraft.wither_skeleton_spawn_egg": "xerar esqueleto do wither",
  "item.minecraft.wolf_spawn_egg": "xerar lobo",
  "item.minecraft.zoglin_spawn_egg": "xerar zoglin",
  "item.minecraft.zombie_spawn_egg": "xerar zombi",
  "item.minecraft.zombie_horse_spawn_egg": "xerar cabalo zombi",
  "item.minecraft.zombie_villager_spawn_egg": "xerar zombi aldeán",
  "item.minecraft.zombified_piglin_spawn_egg": "xerar piglin zombificado",
  "item.minecraft.experience_bottle": "frasco de experiencia",
  "item.minecraft.fire_charge": "bóla de lume",
  "item.minecraft.writable_book": "libro e pluma",
  "item.minecraft.written_book": "libro escrito",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "marco",
  "block.minecraft.flower_pot": "testo",
  "item.minecraft.carrot": "cenoria",
  "item.minecraft.potato": "pataca",
  "item.minecraft.baked_potato": "pataca cociñada",
  "item.minecraft.poisonous_potato": "pataca velenosa",
  "item.minecraft.map": "mapa baleiro",
  "item.minecraft.golden_carrot": "cenoria dourada",
  "block.minecraft.skeleton_skull": "caveira de esqueleto",
  "block.minecraft.wither_skeleton_skull": "caveira de esqueleto do wither",
  "block.minecraft.player_head": "cabeza de xogador",
  "block.minecraft.zombie_head": "cabeza de zombi",
  "block.minecraft.creeper_head": "cabeza de creeper",
  "block.minecraft.dragon_head": "cabeza de dragón",
  "item.minecraft.carrot_on_a_stick": "cenoria nun pau",
  "item.minecraft.warped_fungus_on_a_stick": "fungo deformado nun pau",
  "item.minecraft.nether_star": "estrela do nether",
  "item.minecraft.pumpkin_pie": "torta de cabaza",
  "item.minecraft.firework_rocket": "fogo artificial",
  "item.minecraft.firework_star": "fogo artificial de estrela",
  "item.minecraft.enchanted_book": "libro encantado",
  "item.minecraft.nether_brick": "ladrillos do nether",
  "item.minecraft.quartz": "cuarzo do nether",
  "item.minecraft.tnt_minecart": "vagoneta con dinamita",
  "item.minecraft.hopper_minecart": "vagoneta con funil",
  "item.minecraft.prismarine_shard": "anaco de prismariña",
  "item.minecraft.prismarine_crystals": "cristais de prismariña",
  "item.minecraft.rabbit": "coello cru",
  "item.minecraft.cooked_rabbit": "coello cociñado",
  "item.minecraft.rabbit_stew": "estufado de coello",
  "item.minecraft.rabbit_foot": "pata de coello",
  "item.minecraft.rabbit_hide": "pel de coello",
  "item.minecraft.armor_stand": "soporte de armadura",
  "item.minecraft.iron_horse_armor": "armadura de ferro para cabalo",
  "item.minecraft.golden_horse_armor": "armadura de ouro para cabalo",
  "item.minecraft.diamond_horse_armor": "armadura de diamante para cabalo",
  "item.minecraft.leather_horse_armor": "armadura de coiro para cabalo",
  "item.minecraft.lead": "renda",
  "item.minecraft.name_tag": "etiqueta de nome",
  "item.minecraft.command_block_minecart": "vagoneta con bloque de comandos",
  "item.minecraft.mutton": "cordeiro cru",
  "item.minecraft.cooked_mutton": "cordeiro cociñado",
  "block.minecraft.white_banner": "estandarte branco",
  "block.minecraft.orange_banner": "estandarte laranxa",
  "block.minecraft.magenta_banner": "estandarte maxenta",
  "block.minecraft.light_blue_banner": "estandarte azul claro",
  "block.minecraft.yellow_banner": "estandarte amarelo",
  "block.minecraft.lime_banner": "estandarte lima",
  "block.minecraft.pink_banner": "estandarte rosa",
  "block.minecraft.gray_banner": "estandarte gris",
  "block.minecraft.light_gray_banner": "estandarte gris claro",
  "block.minecraft.cyan_banner": "estandarte ciano",
  "block.minecraft.purple_banner": "estandarte púrpura",
  "block.minecraft.blue_banner": "estandarte azul",
  "block.minecraft.brown_banner": "estandarte marrón",
  "block.minecraft.green_banner": "estandarte verde",
  "block.minecraft.red_banner": "estandarte vermello",
  "block.minecraft.black_banner": "estandarte negro",
  "item.minecraft.end_crystal": "cristal do end",
  "item.minecraft.chorus_fruit": "froita coral",
  "item.minecraft.popped_chorus_fruit": "flocos de froita coral",
  "item.minecraft.beetroot": "remolacha",
  "item.minecraft.beetroot_seeds": "sementes de remolacha",
  "item.minecraft.beetroot_soup": "sopa de remolacha",
  "item.minecraft.dragon_breath": "bafo de dragón",
  "item.minecraft.splash_potion": "poción lanzable non fabricable□sen efectos",
  "item.minecraft.spectral_arrow": "frecha espectral",
  "item.minecraft.tipped_arrow": "frecha con efecto non fabricable□sen efectos",
  "item.minecraft.lingering_potion": "poción alongada non fabricable□sen efectos",
  "item.minecraft.shield": "escudo",
  "item.minecraft.elytra": "élitros",
  "item.minecraft.spruce_boat": "barca de abeto",
  "item.minecraft.birch_boat": "barca de bidueiro",
  "item.minecraft.jungle_boat": "barca de selva",
  "item.minecraft.acacia_boat": "barca de acacia",
  "item.minecraft.dark_oak_boat": "barca de carballo escuro",
  "item.minecraft.totem_of_undying": "tótem da inmortalidade",
  "item.minecraft.shulker_shell": "cuncha de shulker",
  "item.minecraft.iron_nugget": "pebida de ferro",
  "item.minecraft.knowledge_book": "enciclopedia",
  "item.minecraft.debug_stick": "pau de depuración",
  "item.minecraft.music_disc_13": "disco de música□c418 - 13",
  "item.minecraft.music_disc_cat": "disco de música□c418 - cat",
  "item.minecraft.music_disc_blocks": "disco de música□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disco de música□c418 - chirp",
  "item.minecraft.music_disc_far": "disco de música□c418 - far",
  "item.minecraft.music_disc_mall": "disco de música□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disco de música□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disco de música□c418 - stal",
  "item.minecraft.music_disc_strad": "disco de música□c418 - strad",
  "item.minecraft.music_disc_ward": "disco de música□c418 - ward",
  "item.minecraft.music_disc_11": "disco de música□c418 - 11",
  "item.minecraft.music_disc_wait": "disco de música□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disco de música□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□na man principal:□dano de ataque: +8□velocidade de ataque: -2.9",
  "item.minecraft.phantom_membrane": "membrana de pantasma",
  "item.minecraft.nautilus_shell": "cuncha de náutilo",
  "item.minecraft.heart_of_the_sea": "corazón do océano",
  "item.minecraft.crossbow": "bésta",
  "item.minecraft.suspicious_stew": "estufado sospeitoso",
  "block.minecraft.loom": "tear",
  "item.minecraft.flower_banner_pattern": "deseño de estandarte□estampado de flor",
  "item.minecraft.creeper_banner_pattern": "deseño de estandarte□estampado de creeper",
  "item.minecraft.skull_banner_pattern": "deseño de estandarte□estampado de caveira",
  "item.minecraft.mojang_banner_pattern": "deseño de estandarte□símbolo de mojang",
  "item.minecraft.globe_banner_pattern": "deseño de estandarte□estampado de planeta",
  "item.minecraft.piglin_banner_pattern": "deseño de estandarte□fociño",
  "block.minecraft.composter": "composteiro",
  "block.minecraft.barrel": "bocoi",
  "block.minecraft.smoker": "afumadoiro",
  "block.minecraft.blast_furnace": "alto forno",
  "block.minecraft.cartography_table": "mesa de cartografía",
  "block.minecraft.fletching_table": "mesa de frechas",
  "block.minecraft.grindstone": "pedra de amolar",
  "block.minecraft.lectern": "atril",
  "block.minecraft.smithing_table": "mesa de ferraría",
  "block.minecraft.stonecutter": "cortapedras",
  "block.minecraft.bell": "campá",
  "block.minecraft.lantern": "lanterna",
  "block.minecraft.soul_lantern": "lanterna de ánimas",
  "item.minecraft.sweet_berries": "bagas doces",
  "block.minecraft.campfire": "cacharela",
  "block.minecraft.soul_campfire": "cacharela de ánimas",
  "block.minecraft.shroomlight": "cogubrillo",
  "item.minecraft.honeycomb": "favo",
  "block.minecraft.bee_nest": "colmea",
  "block.minecraft.beehive": "abellariza",
  "item.minecraft.honey_bottle": "frasco de mel",
  "block.minecraft.honey_block": "bloque de mel",
  "block.minecraft.honeycomb_block": "bloque de favo",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "bloque de netherita",
  "block.minecraft.ancient_debris": "detritos ancestrais",
  "block.minecraft.target": "albo",
  "block.minecraft.crying_obsidian": "obsidiana chorona",
  "block.minecraft.blackstone": "pedra negra",
  "block.minecraft.blackstone_slab": "lastra de pedra negra",
  "block.minecraft.blackstone_stairs": "escaleiras de pedra negra",
  "block.minecraft.gilded_blackstone": "pedra negra dourada",
  "block.minecraft.polished_blackstone": "pedra negra puída",
  "block.minecraft.polished_blackstone_slab": "lastra de pedra negra puída",
  "block.minecraft.polished_blackstone_stairs": "escaleiras de pedra negra puída",
  "block.minecraft.chiseled_polished_blackstone": "pedra negra puída cicelada",
  "block.minecraft.polished_blackstone_bricks": "ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_brick_slab": "lastra de ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_brick_stairs": "escaleiras de ladrillos de pedra negra puída",
  "block.minecraft.cracked_polished_blackstone_bricks": "ladrillos de pedra gretada negra puída",
  "block.minecraft.respawn_anchor": "áncora de reaparición",
}
export const gl_es = items; 
